import type { ReactNode } from 'react';
import React, { useContext, useMemo } from 'react';

import type { AppMode } from '@jane/shared/types';

interface EcommAppContextProps {
  appMode: AppMode;
}

interface EcommAppContextValues {
  appMode: AppMode;
  isIframe: boolean;
}

export const EcommAppContext = React.createContext<EcommAppContextValues>(
  {} as EcommAppContextValues
);

export const EcommAppProvider = ({
  appMode,
  children,
}: EcommAppContextProps & { children: ReactNode }) => {
  const isIframe = ['embedded', 'operatorEmbed'].includes(appMode);

  const value = useMemo(() => {
    return { appMode, isIframe };
  }, [appMode, isIframe]);

  return (
    <EcommAppContext.Provider value={value}>
      {children}
    </EcommAppContext.Provider>
  );
};

export const useSafeEcommApp = () => useContext(EcommAppContext);

export const useEcommApp = () => {
  const context = useContext(EcommAppContext);

  if (!Object.keys(context).length) {
    throw new Error(
      'useEcommApp must be used within an EcommAppProvider. Use useSafeEcommApp if used within a component shared with non-Ecomm apps'
    );
  }

  return context;
};
